import React from 'react'
import {BrowserRouter, Switch,Redirect, Route } from 'react-router-dom'

import Home from './home/Home';
import LoadingPage from './loading-page/loading-page';
import Loadable from 'react-loadable';
import ScrollToTop from './scroll-to-top/scroll-to-top';
import IndustryReportRouter from './industry-reports/industry-report-router';
import Contact from './contact/Contact'
import OurMethodology from './consulting/OurMethodology/OurMethodology';
import CustomResearch from './consulting/CustomResearch/CustomResearch';
import FlashDelivery from './consulting/FlashDelivery/FlashDelivery';
import Growthpartnership from './consulting/GrowthPatnership/GrowthPatnership';
import PrivacyPolicy from './Misc/PrivacyPolicy/PrivacyPolicy';
import TermsAndConditions from './Misc/TermsAndConditions/TermsAndConditions';
import Client from './clients/Client';
import PressRelease from './press-release/PressRelease';
import PressReleaseDesc from './press-release/press-release-description/PressReleaseDesc';




const AsyncNotFound = Loadable({
    loader: () => import('./not-found/not-found'),
    loading: LoadingPage,
    delay: 5000
})

const Main = () => (
    <main>
        <ScrollToTop>
        <Switch>
            <Route exact path='/' component={Home}/>
            <Route  path='/industry-reports' component={IndustryReportRouter}/>
            <Route  path='/contact-us' component={Contact}/>
            <Route  path='/consulting' component={OurMethodology}/>
            <Route  path='/custom-research' component={CustomResearch}/>
            <Route  path='/flash-delivery' component={FlashDelivery}/>
            <Route  path='/growth-partnership' component={Growthpartnership}/>
            <Route  path='/terms-conditions' component={TermsAndConditions}/>
            <Route  path='/privacy-policy' component={PrivacyPolicy}/>
            <Route  path='/clients' component={Client}/>
            <Route  path='/press-release/' component={PressRelease}/>
            <Route  path='/press-article/:slug' component={PressReleaseDesc}/>
            {/*<Route  path='/site-map' component={SiteMap}/>*/}

            {/*Redirect home if any url entered apart from route defined*/}

            <Route path='*' component={AsyncNotFound} />
            {/*<Redirect from='*' to='/' />*/}
        </Switch>
        </ScrollToTop>

    </main>
)

export default Main



// WEBPACK FOOTER //
// ./src/Main.js